import { UserInfo, UNKNOWN_USER_INFO } from "@/types/user_info";
import { Profile, UNKNOWN_PROFILE } from '@/types/profile';
import { Community, UNKNOWN_COMMUNITY } from '@/types/community';

export interface CommunityMembership {
  uniqueid: string,
  identity_id: number,
  user_info: UserInfo,
  profile: Profile,
  payment_status?: number,
  hidden?: boolean,
  community?: Community,
  unread?: number,
  unread_matches?: number,
  unread_messages?: number,
  reference_distance_km?: number,
  reference_distance_miles?: number,
}

export enum PaymentStatus {
  PAYMENT_STATUS_UNKNOWN = 0,
  PAYMENT_STATUS_SUCCESSFUL = 1,
  PAYMENT_STATUS_PENDING = 2,
};

export const UNKNOWN_COMMUNITY_MEMBERSHIP : CommunityMembership = {
  uniqueid: "-1",
  identity_id: -1,
  user_info: UNKNOWN_USER_INFO,
  profile: UNKNOWN_PROFILE,
  payment_status: PaymentStatus.PAYMENT_STATUS_UNKNOWN,
  hidden: false,
  community: UNKNOWN_COMMUNITY,
  unread: 0,
  unread_matches: 0,
  unread_messages: 0,
  reference_distance_km: undefined,
  reference_distance_miles: undefined,
};

export interface CommunityAndMembership {
  community: Community,
  community_membership: CommunityMembership,
};
